import { PaymentMethod, SacDadosAtendimento } from 'src/contexto/types'
import {
  BannerHeaderResponse,
  getBannerHeader,
  getMenus,
  getPaymentMethods,
  MenusResponse,
} from 'src/services/marketplace-api'
import { getSacInformation } from 'src/services/sac/getSacInformation'

type InitialData = {
  menusData?: MenusResponse
  bannerHeaderData?: BannerHeaderResponse
  sacInformation?: SacDadosAtendimento
  paymentMethods?: PaymentMethod[]
}

const CACHE_DURATION = 15 * 60 * 1000 // 15 minutes in milliseconds
let cacheTimestamp: number | null = null
let cacheInitialData: InitialData | null = null

export const useInitialData = async () => {
  const now = Date.now()
  const cacheExpired = !cacheTimestamp || now - cacheTimestamp > CACHE_DURATION

  if (!cacheInitialData || cacheExpired) {
    const response = await Promise.all([
      getMenus(),
      getBannerHeader(),
      getSacInformation(),
      getPaymentMethods(),
    ])

    cacheInitialData = {
      menusData: response[0] ?? cacheInitialData?.menusData,
      bannerHeaderData: response[1] ?? cacheInitialData?.bannerHeaderData,
      sacInformation: response[2] ?? cacheInitialData?.sacInformation,
      paymentMethods: response[3] ?? cacheInitialData?.paymentMethods,
    }

    cacheTimestamp = now
  }

  return {
    ...cacheInitialData,
  }
}

export const resetInitialDataCache = () => {
  cacheTimestamp = null
  cacheInitialData = null
}
